export default (file) => {
  const fileData = new FormData();
  fileData.set('file', file, file.originalname);
  return fileData;
};
